import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as Excel from "exceljs/dist/exceljs.min.js";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  exportExcel(header: any, data: any, fileName: string) {
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');
    let headerRow = worksheet.addRow(header);
    headerRow.font = { size: 12, bold: true, align: 'center' }

    data.forEach(d => {
      worksheet.addRow(d);
    });
    workbook.xlsx.writeBuffer().then((excelData) => {
      let blob = new Blob([excelData], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, fileName + '' + new Date().getTime() + EXCEL_EXTENSION);
    })
  }

}
